import Alert from "react-bootstrap/esm/Alert";
import Button from "react-bootstrap/esm/Button";
import Modal from "react-bootstrap/esm/Modal";

export interface LogoutModalProps {
    onCancel: VoidFunction;
    onLogout: VoidFunction;
}

export const LogoutModal = ({ onCancel, onLogout }: LogoutModalProps) => {
    return (
        <Modal size="sm" show centered>
            <Modal.Body as={Alert} className="fw-bold m-0">
                <p>Ready to log out?</p>
                <div className="d-flex justify-content-between mt-2">
                    <Button variant="dark" onClick={onCancel}>
                        Cancel
                    </Button>
                    <Button onClick={onLogout}>Log Out</Button>
                </div>
            </Modal.Body>
        </Modal>
    );
};
